import { render, staticRenderFns } from "./ConfirmationDialogActivityItemRule.vue?vue&type=template&id=0dba66e0"
import script from "./ConfirmationDialogActivityItemRule.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogActivityItemRule.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationDialogActivityItemRule.vue?vue&type=style&index=0&id=0dba66e0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports